import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import PublicMap from "components/Map/Map.jsx";

import mapPageStyle from "assets/jss/prehnit/views/mapPageStyle.jsx";

class MapPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapper}>
        <div className={classes.top}>
          <Header
            brand="CLCCro"
            links={<HeaderLinks dropdownHoverColor="primary" />}
            fixed
            color="white"
            className={classes.header}
          />
        </div>
        <div className={classes.middle}>
          <div className={classes.mapContainer}>
            <PublicMap />
          </div>
        </div>
        <div className={classes.bottom}>
          <Footer theme="white" content={<div></div>} className={classes.footer}/>
        </div>
      </div>
    );
  }
}

export default withStyles(mapPageStyle)(MapPage);
